import * as React from "react";
const SvgClose = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 14L14 6M6 6L14 14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgClose;
